<template>
  <div>
    <b-overlay
      :show="isBusyTable"
      rounded="sm"
    >
      <!-- Tabla de materias -->
      <b-card
        no-body
        class="mb-0"
      >
        <transition name="fade-bottom">
          <section v-show="!idMateriaSelected">
            <!-- Datos cargados -->
            <b-card-header class="pb-0">
              <b-card-title />
              <b-card-text class="font-small-2 mr-25 mb-0">
                Datos cargados <b>{{ updatedAt }}</b>
              </b-card-text>
            </b-card-header>

            <!-- Table Top -->
            <div class="m-2">
              <b-row>
                <!-- Cantidad de elementos por página -->
                <b-col
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <span>Mostrar</span>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block mx-50"
                  />
                </b-col>

                <!-- Buscador -->
                <b-col
                  cols="12"
                  md="6"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon
                          :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                          :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                          @click="searchQuery != '' ? searchQuery = '' : ''"
                        />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="searchQuery"
                        placeholder="Buscar"
                      />
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
            </div>

            <!-- Table items -->
            <b-table
              ref="refDataListTable"
              class="position-relative"
              :items="fetchData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              :sort-by.sync="sortBy"
              show-empty
              empty-text="No se encontraron resultados"
              :sort-desc.sync="isSortDirDesc"
            >
              <!-- Column: Clave y nombre -->
              <template #cell(nombre)="data">
                <b-media vertical-align="center">
                  <span class="font-weight-bold d-block text-nowrap text-primary"><b>{{ data.item.clave }}</b></span>
                  <small class="text-muted">{{ data.item.nombre }}</small>
                </b-media>
              </template>

              <!-- Column: Objetivo -->
              <template #cell(objetivo)="data">
                <small class="text-muted">{{ data.item.objetivo }}</small>
              </template>

              <!-- Column: Opciones -->
              <template #cell(opciones)="data">
                <div class="text-nowrap text-center">
                  <!-- Edit icon -->
                  <b-link
                    class="font-weight-bold text-secondary"
                    @click="idMateriaSelected = data.item.id"
                  >
                    <feather-icon
                      :id="`materia-row-${data.item.id}-edit-icon`"
                      icon="ToolIcon"
                      class="cursor-pointer mr-1"
                      size="16"
                    />
                  </b-link>
                  <b-tooltip
                    title="Editar registro"
                    :target="`materia-row-${data.item.id}-edit-icon`"
                  />

                  <!-- Delete icon -->
                  <b-link
                    class="font-weight-bold text-secondary"
                    @click="confirmDeleteAsignature(data.item)"
                  >
                    <feather-icon
                      :id="`plan-row-${data.item.id}-delete-icon`"
                      icon="TrashIcon"
                      class="text-danger cursor-pointer"
                      size="16"
                    />
                  </b-link>
                  <b-tooltip
                    title="Eliminar registro"
                    :target="`plan-row-${data.item.id}-delete-icon`"
                  />
                </div>
              </template>

            </b-table>

            <!-- Table's footer & pagination -->
            <div class="mx-2 mb-2">
              <b-row>
                <!-- Leyenda de cuantos elementos se muestran -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >

                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>
              </b-row>
            </div>
          </section>
        </transition>
      </b-card>
      <!-- Edicion de una materia -->
      <transition name="fade-bottom">
        <section v-if="idMateriaSelected">
          <!-- Alerta de guardado y liga a listado -->
          <b-alert
            variant="danger"
            show
          >
            <div class="alert-body">
              Una vez haya terminado la edición de la materia, <b>no olvide guardar sus cambios</b> y <b
                style="text-decoration: underline;"
                @click="idMateriaSelected = null; refetchData(true); updatedAt = lastUpdate()"
              ><a>presionar aquí</a></b> para volver al listado de materias.
            </div>
          </b-alert>
          <!-- Edición de materias (steps) -->
          <edit-materia
            :id.sync="idMateriaSelected"
            :total-materias="dataAux"
            @refetch-data="refetchData(true); updatedAt = lastUpdate()"
          />
        </section>
      </transition>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BMedia,
  BAlert,
  BPagination,
  BCardHeader,
  BCardText,
  BCardTitle,
  BTooltip,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onMounted, watch } from '@vue/composition-api'
import { lastUpdate } from '@core/utils/filter'
import { isEmptyObject } from '@core/utils/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import {
  configTableMaterias,
} from '@/views/campus/servicio-escolar/useServicioEscolar'
import EditMateria from './components/EditMateria.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAlert,
    BCardHeader,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupPrepend,
    BTooltip,
    BLink,
    BPagination,
    vSelect,
    BOverlay,
    EditMateria,
  },
  methods: {
    confirmDeleteAsignature(asignature) {
      this.$swal({
        title: '¿Está seguro de eliminar?',
        html: `Si continúa se eliminará la materia: <b>"${asignature.nombre}"</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteAsignature({ action: 5, materia: asignature.id })
        }
      })
    },
    deleteAsignature(dataModule) {
      this.isBusyTable = true
      // eslint-disable-next-line no-param-reassign
      dataModule.task = 'wsmaterias'

      this.$store.dispatch('servicioEscolar/postServicioEscolar', dataModule)
        .then(response => {
          this.isBusyTable = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
          this.refetchData(true); this.updatedAt = lastUpdate()
        }, error => {
          this.isBusyTable = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [CRUD Materias]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    },
  },
  setup() {
    const updatedAt = ref(lastUpdate())
    const loader = ref({ filters: false })
    const errorContent = ref({ filters: false })
    const idMateriaSelected = ref(null)
    const { tableColumns, configRequest } = configTableMaterias()
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable, dataAux,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
    } = useFillDataTable()

    //* On mounted
    onMounted(() => {
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
    })

    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data

    return {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      dataAux,

      // Filter
      updatedAt,
      lastUpdate,

      // Extra Filters
      idMateriaSelected,
      isEmptyObject,

      // Loader
      loader,
      isBusyTable,

      // Error
      errorContent,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
